import SiteConfig from "site-config.json";

const siteConfig = {
    schoolName: () => (SiteConfig && SiteConfig["school-name"]) || "School",

    logo: () => (SiteConfig && SiteConfig.logo) || "/default-logo.png",

    footerHeaderBg: () =>
        (SiteConfig && SiteConfig["footer-header-bg"]) || undefined,

    logoutColor: () => (SiteConfig && SiteConfig["logout-color"]) || "#333",

    logoutFontColor: () =>
        (SiteConfig && SiteConfig["logout-font-color"]) || "#fff",

    headerColor: () => (SiteConfig && SiteConfig["header-color"]) || undefined,

    headerMain: () => (SiteConfig && SiteConfig["header-main"]) || undefined,

    footerLogo: () => (SiteConfig && SiteConfig["footer-logo"]) || undefined,

    footerWrap: () => (SiteConfig && SiteConfig["footer-wrap"]) || undefined,

    footerColor: () => (SiteConfig && SiteConfig["footer-color"]) || undefined,

    footerInfo: () => (SiteConfig && SiteConfig["footer-info"]) || undefined,

    helpButtonColor: () =>
        (SiteConfig && SiteConfig["help-button-color"]) || "#007bff",

    helpButtonFontColor: () =>
        (SiteConfig && SiteConfig["help-button-font-color"]) || "#fff",

    headerBorderColor: () =>
        (SiteConfig && SiteConfig["header-border-color"]) || undefined,

    headerFontColor: () =>
        (SiteConfig && SiteConfig["header-font-color"]) || undefined,

    logout: () => (SiteConfig && SiteConfig.logout) || undefined,
};

export default siteConfig;



// WEBPACK FOOTER //
// ./src/utils/siteConfig.js